"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _crossPlatformComponents = require("@airasia/cross-platform-components");

var _AaPassengerRoomSelection = require("./AaPassengerRoomSelection.model");

var _helpers = require("./helpers");

var InputSummary = function InputSummary(props) {
  var roomOccupancy = props.data.map(function (room) {
    var _ref;

    return _ref = {}, (0, _defineProperty2["default"])(_ref, _AaPassengerRoomSelection.PASSENGER_TYPE.ADULT, room[_AaPassengerRoomSelection.PASSENGER_TYPE.ADULT]), (0, _defineProperty2["default"])(_ref, _AaPassengerRoomSelection.PASSENGER_TYPE.CHILD, room[_AaPassengerRoomSelection.PASSENGER_TYPE.CHILD] + room[_AaPassengerRoomSelection.PASSENGER_TYPE.INFANT]), _ref;
  });
  var adultText = (0, _helpers.getGuestText)(roomOccupancy, props.translation, _AaPassengerRoomSelection.PASSENGER_TYPE.ADULT);
  var childText = (0, _helpers.getGuestText)(roomOccupancy, props.translation, _AaPassengerRoomSelection.PASSENGER_TYPE.CHILD);
  var roomText = props.translation.paxRoomLabel.replace("{0}", roomOccupancy.length);
  var labelForInput = [adultText, childText, roomText].filter(Boolean).join(', ');
  return /*#__PURE__*/_react["default"].createElement(_crossPlatformComponents.AaTextInputComponent, {
    translation: {
      title: props.translation.occupancyLabel
    },
    controls: {
      attrName: "roomOccupancy",
      value: labelForInput,
      onInputFocus: function onInputFocus() {},
      isFloatingLabelRequired: true,
      textInputStyles: {
        textOverflow: 'ellipsis'
      },
      otherTextInputProps: {
        editable: false
      }
    }
  });
};

var _default = InputSummary;
exports["default"] = _default;